import { formatLongTermMedicationsToString } from "features/medications/utils/formatLongTermMedications";

// Read-only, multi-line summary of a patient's 12-month medication &
// vaccination history (PatientMedicationHistoryDTO) for the antenatal
// consultation reference box (KIN-1085). Reuses the shared medication formatter
// for the prescribed/discontinued lists; vaccinations are name + date given.
export const formatMedicationHistoryToString = (history) => {
  if (!history) return "";

  const sections = [];

  const prescribed = formatLongTermMedicationsToString(history.prescribed ?? []);
  if (prescribed) {
    sections.push(`Prescribed (last ${history.windowMonths ?? 12} months):\n${prescribed}`);
  }

  const discontinued = formatLongTermMedicationsToString(
    history.discontinued ?? []
  );
  if (discontinued) {
    sections.push(`Discontinued:\n${discontinued}`);
  }

  const vaccinations = (history.vaccinations ?? [])
    .map((vaccination) =>
      [vaccination.vaccineName, vaccination.dateGiven]
        .filter(Boolean)
        .join(" — ")
    )
    .filter(Boolean)
    .join("\n");
  if (vaccinations) {
    sections.push(`Vaccinations:\n${vaccinations}`);
  }

  return sections.join("\n\n");
};
